export default __webpack_public_path__ + "static/media/illustration-recruit-6-m@3x.112210cc.webp";